import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const blank = { title: '', description: '', discount_percent: '', applicable_to: 'all', transport_mode: 'all', goods_filter: '', start_date: '', end_date: '' };

export default function AdminPromotions() {
  const [promos, setPromos] = useState([]);
  const [form, setForm] = useState(blank);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = () => axios.get('/api/admin/promotions').then(r => setPromos(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.title.trim() || !form.description.trim() || !form.discount_percent || !form.start_date || !form.end_date) {
      return toast.error('Fill in title, description, discount, start date, and end date');
    }

    setSaving(true);
    try {
      await axios.post('/api/admin/promotions', form);
      toast.success('Promotion created');
      setForm(blank); setShowForm(false); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Failed to create'); }
    finally { setSaving(false); }
  };

  const toggle = async (promo) => {
    try {
      await axios.put(`/api/admin/promotions/${promo.id}`, { ...promo, is_active: !promo.is_active });
      toast.success(`Promotion ${promo.is_active ? 'deactivated' : 'activated'}`);
      load();
    } catch { toast.error('Failed'); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this promotion?')) return;
    try { await axios.delete(`/api/admin/promotions/${id}`); toast.success('Deleted'); load(); }
    catch { toast.error('Failed'); }
  };

  return (
    <div>
      <div className="page-header">
        <Link to="/admin" className="back-btn">←</Link>
        <h1>Promotions 🎉</h1>
        <button className="btn btn-primary btn-sm" onClick={() => setShowForm(!showForm)}>+ New</button>
      </div>
      <div className="page-content">
        {showForm && (
          <div className="card" style={{ border: '1.5px solid #1A6B8A', marginBottom: 16 }}>
            <p style={{ fontWeight: 700, marginBottom: 12 }}>New Promotion</p>
            <div className="input-group"><label>Title</label><input className="input-field" value={form.title} onChange={e => setForm({...form, title: e.target.value})} placeholder="e.g. March Madness" /></div>
            <div className="input-group"><label>Description</label><input className="input-field" value={form.description} onChange={e => setForm({...form, description: e.target.value})} /></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div className="input-group"><label>Discount %</label><input className="input-field" type="number" min="1" max="100" value={form.discount_percent} onChange={e => setForm({...form, discount_percent: e.target.value})} /></div>
              <div className="input-group"><label>Route</label>
                <select className="input-field" value={form.applicable_to} onChange={e => setForm({...form, applicable_to: e.target.value})}>
                  <option value="all">All Routes</option>
                  <option value="cn_gh">China → Ghana</option>
                  <option value="tr_gh">Turkey → Ghana</option>
                  <option value="specific_goods">Specific Goods</option>
                </select>
              </div>
            </div>
            <div className="input-group"><label>Cargo Type</label>
              <select className="input-field" value={form.transport_mode} onChange={e => setForm({...form, transport_mode: e.target.value})}>
                <option value="all">Sea &amp; Air</option>
                <option value="sea">Sea Freight Only</option>
                <option value="air">Air Freight Only</option>
              </select>
            </div>
            {form.applicable_to === 'specific_goods' && (
              <div className="input-group"><label>Goods Filter (keyword match)</label><input className="input-field" placeholder="e.g. 假发 or shoes" value={form.goods_filter} onChange={e => setForm({...form, goods_filter: e.target.value})} /></div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div className="input-group"><label>Start Date</label><input className="input-field" type="date" value={form.start_date} onChange={e => setForm({...form, start_date: e.target.value})} /></div>
              <div className="input-group"><label>End Date</label><input className="input-field" type="date" value={form.end_date} onChange={e => setForm({...form, end_date: e.target.value})} /></div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-primary btn-sm" onClick={save} disabled={saving}>{saving ? <span className="spinner" /> : 'Create'}</button>
              <button className="btn btn-ghost btn-sm" onClick={() => setShowForm(false)}>Cancel</button>
            </div>
          </div>
        )}

        {promos.length === 0 ? <div className="empty-state"><div className="icon">🎉</div><p>No promotions yet</p></div>
          : promos.map(p => (
            <div className="card" key={p.id} style={{ opacity: p.is_active ? 1 : 0.6 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <p style={{ fontWeight: 700 }}>{p.title}</p>
                    {p.active_today
                      ? <span style={{ background: '#dcfce7', color: '#16a34a', fontSize: 10, padding: '2px 8px', borderRadius: 20, fontWeight: 700 }}>LIVE NOW</span>
                      : p.is_active
                        ? <span style={{ background: '#fef9c3', color: '#a16207', fontSize: 10, padding: '2px 8px', borderRadius: 20, fontWeight: 700 }}>SCHEDULED</span>
                        : <span style={{ background: '#fee2e2', color: '#dc2626', fontSize: 10, padding: '2px 8px', borderRadius: 20, fontWeight: 700 }}>INACTIVE</span>
                    }
                  </div>
                  <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>{p.description}</p>
                  <p style={{ fontSize: 12, fontWeight: 700, color: '#F4A624' }}>
                    {p.discount_percent}% off
                    {' · '}
                    {p.applicable_to === 'all' ? 'All Routes' : p.applicable_to === 'cn_gh' ? 'CN → GH' : p.applicable_to === 'tr_gh' ? 'TR → GH' : 'Specific Goods'}
                    {p.transport_mode && p.transport_mode !== 'all' ? ` · ${p.transport_mode === 'sea' ? 'Sea Only' : 'Air Only'}` : ''}
                  </p>
                  <p style={{ fontSize: 11, color: '#9ca3af' }}>{p.start_date} → {p.end_date}</p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginLeft: 8 }}>
                  <button onClick={() => toggle(p)} className={`btn btn-sm ${p.is_active ? 'btn-danger' : 'btn-success'}`} style={{ fontSize: 11 }}>{p.is_active ? 'Deactivate' : 'Activate'}</button>
                  <button onClick={() => del(p.id)} className="btn btn-sm" style={{ background: '#fee2e2', color: '#dc2626', fontSize: 11 }}>Delete</button>
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}
